var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabymamLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 38,
    viewBox: "0 0 130 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4728_20336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6913V36.2264C2.32973 36.5116 4.61191 36.7018 6.94164 36.7494C19.874 36.7494 24.9138 30.9488 24.9138 24.4351C24.9614 15.9244 15.3097 11.4551 0 12.6913Z",
    fill: "url(#paint0_linear_4728_20336)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.7043 15.147C19.4524 13.7239 19.8273 12.1611 19.9216 10.5982C19.874 5.63152 14.3112 -0.767907 0 0.330501V12.6918C7.9483 12.05 14.3716 12.946 18.7043 15.147Z",
    fill: "url(#paint1_linear_4728_20336)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8154 25.7811H39.9342C42.6154 25.7811 44.6873 24.0748 44.6873 21.5764C44.6873 19.017 42.6764 18.2857 42.4732 18.2451C42.6764 18.1842 43.9561 17.3514 43.9561 15.6248C43.9561 12.6389 41.742 11.5623 39.4264 11.5623H34.8154V25.7811ZM39.8529 23.4654H37.2529V19.6873H39.8529C41.1936 19.6873 42.2092 20.2357 42.2092 21.5764C42.2092 22.917 41.1936 23.4654 39.8529 23.4654ZM37.2529 17.3717V13.8779H39.3451C40.5436 13.8779 41.4779 14.3857 41.4779 15.6248C41.4779 16.8639 40.7061 17.3717 39.3451 17.3717H37.2529Z",
    fill: "#6B1D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2904 23.9936C49.5388 23.9936 48.5435 23.7701 48.5435 22.7545C48.5435 21.7186 49.5794 21.3936 50.331 21.3936C51.6513 21.3936 52.5248 21.8811 52.5248 21.8811V22.8764C52.5248 22.8764 51.7529 23.9936 50.2904 23.9936ZM50.5748 15.9092C48.5638 15.9092 46.7763 16.7826 46.7763 16.7826L47.5685 18.7936C47.5685 18.7936 49.0513 18.0826 50.4529 18.0826C51.306 18.0826 52.5248 18.4889 52.5248 19.7482V20.2967C52.5248 20.2967 51.6107 19.6061 49.8435 19.6061C47.7513 19.6061 46.0654 20.9467 46.0654 22.7951C46.0654 24.8467 47.731 26.0248 49.5388 26.0248C51.7123 26.0248 52.7076 24.5623 52.7076 24.5623V25.7811H54.9623V19.5045C54.9623 17.3107 53.3373 15.9092 50.5748 15.9092Z",
    fill: "#6B1D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6868 25.7811H59.9415V24.5217C59.9415 24.5217 60.7743 26.0248 62.8462 26.0248C65.3446 26.0248 67.5384 23.9326 67.5384 20.967C67.5384 18.0014 65.3446 15.9092 62.8462 15.9092C61.0181 15.9092 60.1243 17.1686 60.1243 17.1686V10.4248H57.6868V25.7811ZM60.1243 19.5248C60.1243 19.5248 60.815 18.1842 62.4196 18.1842C64.065 18.1842 65.0603 19.3826 65.0603 20.967C65.0603 22.5514 64.065 23.7498 62.4196 23.7498C60.815 23.7498 60.1243 22.4092 60.1243 22.4092V19.5248Z",
    fill: "#6B1D66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5116 29.6811C68.5116 29.6811 69.6288 30.6967 71.0913 30.6967C72.5132 30.6967 73.8741 30.0467 74.707 27.9342L79.3788 16.1529H76.7585L74.2195 23.2014L70.9695 16.1529H68.2679L72.9601 26.0045L72.5741 26.9998C72.107 28.1779 71.7616 28.4217 70.9288 28.4217C70.2991 28.4217 69.6491 27.792 69.6491 27.792L68.5116 29.6811Z",
    fill: "#6B1D66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.886 11.5623V25.7811H89.3235V16.2342L93.772 22.9982L98.2204 16.2342V25.7811H100.658V11.5623H98.4032L93.772 18.7123L89.1407 11.5623H86.886Z",
    fill: "#6B1D66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.161 23.9936C106.41 23.9936 105.415 23.7701 105.415 22.7545C105.415 21.7186 106.45 21.3936 107.202 21.3936C108.522 21.3936 109.396 21.8811 109.396 21.8811V22.8764C109.396 22.8764 108.624 23.9936 107.161 23.9936ZM107.446 15.9092C105.435 15.9092 103.647 16.7826 103.647 16.7826L104.44 18.7936C104.44 18.7936 105.922 18.0826 107.324 18.0826C108.177 18.0826 109.396 18.4889 109.396 19.7482V20.2967C109.396 20.2967 108.482 19.6061 106.715 19.6061C104.622 19.6061 102.936 20.9467 102.936 22.7951C102.936 24.8467 104.602 26.0248 106.41 26.0248C108.583 26.0248 109.579 24.5623 109.579 24.5623V25.7811H111.833V19.5045C111.833 17.3107 110.208 15.9092 107.446 15.9092Z",
    fill: "#6B1D66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.445 15.9092C123.191 15.9092 122.378 17.5951 122.378 17.5951C122.378 17.5951 121.708 15.9092 119.392 15.9092C117.422 15.9092 116.548 17.5545 116.548 17.5545V16.1529H114.273V25.7811H116.711V19.4232C116.711 19.4232 117.32 18.1842 118.6 18.1842C119.819 18.1842 120.327 18.8951 120.327 20.2154V25.7811H122.764V19.4232C122.764 19.4232 123.373 18.1842 124.653 18.1842C125.872 18.1842 126.38 18.8951 126.38 20.2154V25.7811H128.817V19.5857C128.817 17.2701 127.395 15.9092 125.445 15.9092Z",
    fill: "#6B1D66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4728_20336",
    x1: 0,
    y1: 24.6309,
    x2: 24.9566,
    y2: 24.6309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58398",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4728_20336",
    x1: 0,
    y1: 7.69476,
    x2: 19.8883,
    y2: 7.69476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58398",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58398"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4728_20336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9614,
    height: 36.5625,
    fill: "white",
    transform: "translate(0 0.1875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabymamLogoMobile);
export default __webpack_public_path__ + "static/media/babymam-logo-mobile.1c81117176edc98baf10468fa7f2d9f1.svg";
export { ForwardRef as ReactComponent };